export default __webpack_public_path__ + "static/f9b8318c-4752-4c4c-9ccc-c31fdd54b534-33f6b98703f395174a953a8b4e1fcb52.jpeg";